import { inject, Service } from '@angular/core';
import { MbmError } from './mbm-error';
import { ErrorMessageService } from './error-message.service';

@Service()
export class ErrorHandlingService {
  private static readonly VALIDATION_ERROR_STATUS = 460;
  private static readonly ERROR_CODE_TRANSLATION_KEYS = new Map<number, string>([
    [1, 'errors.validation.mandatoryFieldMissing'],
    [2, 'errors.validation.maximumCharactersReached'],
    [3, 'errors.validation.duplicateEntry'],
    [4, 'errors.validation.insufficientPermissions'],
    [5, 'errors.validation.externalServiceError'],
    [6, 'errors.validation.invalidValue'],
  ]);

  private readonly errorMessageService = inject(ErrorMessageService);

  async handleErrorAsync(error: unknown, messageKey?: string): Promise<never> {
    const mbmError = error as MbmError;

    if (mbmError.statusCode === ErrorHandlingService.VALIDATION_ERROR_STATUS) {
      this.displayValidationError(mbmError);
      mbmError.logError = false;
      throw mbmError;
    }

    if (messageKey) {
      this.errorMessageService.showError(messageKey);
    }
    mbmError.handled = true;
    mbmError.logError = true;
    throw mbmError;
  }

  private displayValidationError(error: MbmError): void {
    const key = this.getValidationMessageKey(error.validationErrorCode);
    this.errorMessageService.showValidationError(key);
    error.handled = true;
  }

  private getValidationMessageKey(code?: number): string {
    if (!code) {
      return 'errors.validation.default';
    }
    return ErrorHandlingService.ERROR_CODE_TRANSLATION_KEYS.get(code) ?? 'errors.validation.default';
  }
}
